<script setup lang="ts">
const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const blogs = computed(() => props?.slice?.Blogs?.filter((blog: Record<string, unknown>) => !!blog) || [])

// const { settings } = useSliderSettings()
// const sliderSettings = Object.assign({}, settings, {
//   itemsToShow: 1.25,
//   breakpoints: {
//     700: {
//       itemsToShow: 2,
//       itemsToScroll: 2,
//     },
//     1024: {
//       itemsToShow: 3,
//       itemsToScroll: 3,
//     },
//   },
// })

// const carousel = ref()
// const showNavigation = computed(() => {
//   return carousel.value?.data?.slidesCount.value > carousel.value?.data?.config?.itemsToShow
// })
</script>

<template>
  <StrapiSlice
    class="ct-blog-feed"
    :slice="slice"
    :index="index"
  >
    <UiCarousel
      v-if="slice?.FeedDisplay?.Display === 'Slider'"
      class="ct-blog-feed__carousel"
      :class="{
        /* Non responsive & non modern settings */
        'ui-carousel--center': false,
        'ui-carousel--free-scroll': true,
        'ui-carousel--navigation': true,
        'ui-carousel--pagination': false,
        'ui-carousel--progress': false,
      }"
    >
      <template
        v-for="(blog, i) in blogs"
        #[`slide-${i}`]
        :key="blog"
      >
        <BlogTile
          :blog="blog"
          :lazy="index > 0 || i > 2"
          class="ct-blog-feed__blog"
        />
      </template>
    </UiCarousel>

    <div
      v-else-if="slice?.FeedDisplay?.Display === 'Grid' && blogs?.length"
      class="ct-blog-feed__grid"
    >
      <BlogTile
        v-for="(blog, i) in blogs"
        :key="blog"
        :blog="blog"
        :lazy="index > 0 || i > 2"
        class="ct-blog-feed__blog"
      />
    </div>
  </StrapiSlice>
</template>

<style>
@import url("~layers/app/components/Slices/BlogFeed.css");
</style>
